const SESSION_KEY = "sessionid"

const getFromStorage = storage => {
  if (!storage || typeof storage.getItem !== "function") {
    return ""
  }
  try {
    return storage.getItem(SESSION_KEY) || ""
  } catch (err) {
    return ""
  }
}

const persistSessionId = value => {
  if (!value || typeof window === "undefined") {
    return
  }
  try {
    if (window.sessionStorage) {
      window.sessionStorage.setItem(SESSION_KEY, value)
    }
  } catch (err) {
    // ignore storage errors (e.g. Safari private mode)
  }
}

const getFromQuery = () => {
  if (typeof window === "undefined" || !window.location) {
    return ""
  }
  const params = new URLSearchParams(window.location.search || "")
  const fromQuery = params.get(SESSION_KEY) || ""
  if (fromQuery) {
    persistSessionId(fromQuery)
  }
  return fromQuery
}

const generateSessionId = () => {
  if (typeof crypto !== "undefined") {
    if (crypto.randomUUID) {
      return crypto.randomUUID()
    }
    if (crypto.getRandomValues) {
      const buffer = new Uint32Array(4)
      crypto.getRandomValues(buffer)
      return Array.from(buffer, part =>
        part.toString(16).padStart(8, "0")
      ).join("")
    }
  }
  return `session-${Date.now()}-${Math.random().toString(16).slice(2)}`
}

export const getSessionId = () => {
  if (typeof window === "undefined") {
    return ""
  }

  const fromQuery = getFromQuery()
  if (fromQuery) {
    return fromQuery
  }

  const fromSessionStorage = getFromStorage(window.sessionStorage)
  if (fromSessionStorage) {
    return fromSessionStorage
  }

  const generated = generateSessionId()
  persistSessionId(generated)
  return generated
}

export { SESSION_KEY, generateSessionId, persistSessionId }
